<template>
  <lcontainer class="py-12 px-12">
    <lCrumbs :breadcrumb="breadcrumbItems" />
    <div class="w-full">
      <div class="md:flex md:items-center md:w-1/3">
        <div class="md:w-1/3">
          <label class="font-semibold " for=""> Survey Title:</label>
        </div>
        <div class="md:w-2/3">
          <linput
            v-model="form.title"
            :error="errors.title"
            type="text"
            placeholder="Survey Title"
          ></linput>
        </div>
      </div>
    </div>
    <div class="mt-6">
      <div class="md:flex md:items-center md:w-1/3">
        <div class="md:w-1/3">
          <label class="font-semibold " for="reward-points">
            Reward Points:</label
          >
        </div>
        <div class="md:w-2/3">
          <linput
            id="reward-points"
            v-model="form.reward_point"
            :error="errors.reward_point"
            type="text"
            placeholder="Enter Reward points"
          ></linput>
        </div>
      </div>
    </div>
    <div class="mt-6">
      <div class="md:flex md:items-center md:w-1/3">
        <div class="md:w-1/3">
          <label class="font-semibold " for="reward-points">
            Disable survey for user once taken:</label
          >
        </div>
        <div class="md:w-2/3">
          <input
            type="radio"
            v-model="form.disable_on_submit"
            value="1"
            name="survey-disable"
          />
          <label for="">Yes</label>
          <input
            class="ml-4"
            type="radio"
            v-model="form.disable_on_submit"
            value="0"
            name="survey-disable"
          />
          <label for="">No</label>
        </div>
      </div>
    </div>
    <div class="mt-10">
      <div class="md:px-24">
        <div class="md:flex md:justify-end z-10 top-0 sticky md:mb-12">
          <lms-button
            class=""
            @click="addQuestion"
            :color="`#0B85E4`"
            textColor="#fff"
            >Add Question</lms-button
          >
        </div>
        <div
          v-if="questions && questions.length > 0"
          v-for="(que, index) in questions"
          class="mb-12"
          :key="index"
        >
          <div class="flex justify-between">
            <span class="font-lg font-semibold mb-6"
              >Question {{ index + 1 }}</span
            >
            <span
              @click="removeQue(que.id)"
              v-if="questions.length > 1"
              class="text-red-600 cursor-pointer"
              >Remove</span
            >
          </div>
          <div>
            <textarea
              v-model="que.question_text"
              class="rounded-lg resize-none md:w-full border border-gray-300 focus:outline-none px-2 py-2 mb-6"
              placeholder="Enter question here"
              rows="10"
            ></textarea>
          </div>
          <div>
            <div class="md:flex md:justify-around md:items-center mb-6">
              <div class="">
                <input
                  class="mr-2 leading-tight"
                  v-model="que.has_options"
                  type="checkbox"
                />
                <label class="text-sm">
                  Has Options?
                </label>
              </div>
              <label class="text-gray-500 font-bold">
                <a
                  v-if="
                    que.options !== null &&

                      que.has_options
                  "
                  @click="addOption(que.id)"
                  class="cursor-pointer mt-3 md:mt-0 text-green-500"
                  >Add Option</a
                >
              </label>
            </div>
          </div>
          <div class="md:px-16 md:mt-6">
            <div
              v-if="que.has_options == 1 && que.options !== null"
              v-for="(option, index) in que.options"
              class="md:flex md:mb-4 md:items-center w-full bg-"
              :key="index"
            >
              <p class="text-black mr-4 mb-2 md:mt-0">Option {{ index + 1 }}</p>
              <input
                type="text"
                v-model="option.answer"
                class="w-full md:w-2/4 h-10 border p-2 rounded w-auto focus:outline-none mr-4"
                placeholder="Enter option here"
              />
              <a
                v-if="que.options != null && que.options.length > 1"
                @click="removeOption($event, que.id, option.id)"
                class="block mt-3 md:mt-0 cursor-pointer text-red-500"
                >remove</a
              >
            </div>
          </div>
        </div>
        <div class="md:flex md:justify-end z-10 md:mb-12">
          <lms-button
            class=""
            @click="submitSurvey"
            :color="`#27AE60`"
            textColor="#fff"
            >Update</lms-button
          >
        </div>
      </div>
    </div>
  </lcontainer>
</template>
<script>
import { mapActions, mapMutations } from "vuex";
export default {
  data() {
    return {
      form: {},
      errors: [],
      questions: [],
      breadcrumbItems: [
        {
          disabled: true,
          to: "/tenant/surveys",
          text: "All Surveys",
        },
        {
          disabled: true,
          to: "#",
          text: "Edit Survey",
        },
      ],
    };
  },
  methods: {
    ...mapMutations(["updateLoader"]),
    ...mapActions([
      "tenantUpdateSurvey",
      "tenantRemoveSurveyQuestion",
      "tenantSingleSurvey",
    ]),
    async submitSurvey() {
      this.errors = [];
      let questions = this.questions.map((item) => {
        if (item.has_options == true || item.has_options == 1) {
          let arr = [];
          item.options.forEach((option) => {
            arr.push(option.answer);
          });
          item.options = arr;
        } else {
          item["options"] = [];
        }
        return item;
      });
      this.form.questions = questions;
      this.form.reward_point = parseInt(this.form.reward_point);

      this.updateLoader(true);
      let res = await this.tenantUpdateSurvey({
        id: this.form.id,
        survey: this.form,
      });
      this.updateLoader(false);

      if (res == true || res.status == 200) {
        this.$Bus.$emit("notify", {
          type: "success",
          message: "Survey updated successfully",
        });
        this.$router.push({
          name: "tenant-survey-home",
        });
      } else {
        this.errors = res.data.errors[0].source;
        this.$Bus.$emit("notify", {
          type: "error",
          message: res.data.errors
            ? res.data.errors[0].title
            : "An error occured",
        });
      }
    },
    addQuestion() {
      this.questions.push({
        id: Date.now(),
        question_text: "",
        has_options: false,
        options: [{ id: `option-${Date.now()}`, answer: "" }],
      });
    },
    async removeQue(id) {
      let res = await this.tenantRemoveSurveyQuestion({ id });
      this.questions = this.questions.filter((item) => item.id !== id);
    },
    addOption(queId) {
      this.questions.filter((item) => {
        if (item.id == queId) {
          if (item.options ) {
            item.options.push({ id: `option-${Date.now()}`, answer: "" });
          }
        }
      });
    },
    removeOption(e, queId, optionId) {
      this.questions.filter((item) => {
        if (item.id == queId) {
          item.options = item.options.filter((op) => op.id !== optionId);
        }
      });
    },
  },
  async created() {
    this.updateLoader(true);
    let res = await this.tenantSingleSurvey({
      id: this.$route.params.survey_id,
    });
    this.updateLoader(false);
    this.form = res;

    let arr = res.questions.map((item) => {
      let { has_options, id, options, question_text } = item;
      let optionsArr;
      if (options && options.length) {
        optionsArr = options.map((item, index) => {
          return {
            id: `option-${Date.now() + index}`,
            answer: item,
          };
        });
      } else {
        optionsArr = [{ id: `option-${Date.now()}`, answer: "" }];
      }

      return { has_options, id, options: optionsArr, question_text };
    });

    this.questions = arr;
    delete this.form.questions;
  },
  components: {
    lcontainer: () => import("@/components/general/container"),
    LmsButton: () => import("@/components/general/button"),
    linput: () => import("@/components/general/input"),
    lCrumbs: () => import("@/components/general/breadcrumbs.vue"),
  },
};
</script>
<style scoped></style>
